import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { MenuEffects } from './menu.effects'
import { menuReducer } from './menu.reducer'
import { FEATURE_NAME } from './menu.state'

@NgModule({
  imports: [
    SharedModule,
    StoreModule.forFeature(FEATURE_NAME, menuReducer),
    EffectsModule.forFeature([MenuEffects])
  ],
  providers: [],
  declarations: [],
  exports: []
})
export class MenuModule {}
